import React from "react";
import PropTypes from "prop-types";
import {AutoSizer, List} from "react-virtualized";

import ReferralPopupContentListReferrerItem from "./ReferralPopupContentListReferrerItem";
import ReferralPopupContentListProviderItem from "./ReferralPopupContentListProviderItem";


const ReferralPopupContentList = (props) => {

  const {fabricatorsList, side} = props;

  return (
    <div className="absolute h-full ui-list w-full font--16 text-left color-blue">
      <AutoSizer>
        {({width, height}) => {
          return (
            <List
              height={height}
              className="scrollbar3 pr-1"
              width={width}
              rowCount={fabricatorsList.length}
              rowHeight={44}
              rowRenderer={({index, key, style}) => {
                if (!fabricatorsList[index]) {
                  return null
                }
                return side === "left"
                  ? <ReferralPopupContentListReferrerItem key={key + fabricatorsList[index].name}
                                                          style={style}
                                                          fabricator={fabricatorsList[index]}/>
                  : <ReferralPopupContentListProviderItem key={key + fabricatorsList[index].name}
                                                          style={style}
                                                          fabricator={fabricatorsList[index]}/>
              }}
            />
          )
        }}
      </AutoSizer>
    </div>
  )
};

ReferralPopupContentList.propTypes = {
  fabricatorsList: PropTypes.array.isRequired,
  side: PropTypes.string,
}

export default ReferralPopupContentList
